/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { I18nService } from '@dm/core';
import { type Observable } from 'rxjs';

import { InfigoService } from '../../../infigo.service';
import { SourceEnumService } from '../../../source-enum.service';
import { RefreshComponent } from '../../RefreshComponent';

@Component({
    selector: 'app-port-group-base-info',
    templateUrl: './port-group-base-info.component.html',
})
export class PortGroupBaseInfoComponent extends RefreshComponent {
    @Input() item;
    detail = {};
    loading = true;
    baseInfo;

    constructor(
        public infigoService: InfigoService,
        public i18n: I18nService,
        public enumService: SourceEnumService,
        public changeDetectorRef: ChangeDetectorRef,
    ) {
        super();
        const I18N = i18n.get;
        const enumGet = enumService.get.bind(enumService, 'PORTGROUP');
        this.baseInfo = [
            {
                title: I18N('host.portGroup_term_portsNum_cloum'),
                key: 'portNum',
            },
            {
                title: I18N('common.mapping_column'),
                key: 'isAddToMappingView',
                enumMap: enumGet('isAddToMappingView'),
            },
            {
                title: I18N('common.portType_label'),
                key: 'portType',
                enumMap: enumGet('portType'),
            },
            {
                title: I18N('common.description_column'),
                key: 'DESCRIPTION',
                isLongString: true,
            },
        ];
    }

    requestInfo(): Observable<any> {
        return this.infigoService.getPortGroup(this.item.actionParams);
    }

    handleRequest(value: any): void {
        this.detail = value.data;
        this.loading = false;
        this.clearTimer();
        this.updateLoading = false;
        this.changeDetectorRef.detectChanges();
    }
}
